import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		root: {
			minWidth: theme.spacing(20),
		},
	}),
	{ name: 'Questions-AnswerTypes-SubmitButton' },
)

export default useStyles
